<template>
    <div class="header">
        <el-drawer class="el_drawermodal" title="" :visible.sync="drawer" :direction="direction" :modal="false" :modal-append-to-body="false" :show-close="true">
            <!-- 自定义标题区域 -->
            <template #title>
                <div class="drawer-title">
                    <div class="logo" @click="changeindex">
                        <img class="header_logo" src="@/assets/images/all/logo_title.png" alt="两仪万象" />
                    </div>
                    <!-- 关闭按钮保持默认位置 -->
                </div>
            </template>
            <!-- 抽屉菜单内容 -->
            <div class="drawer-content">

                <!-- 目录标题 -->
                <div class="menu-title">Menu</div>

                <!-- 导航菜单列表 -->
                <div class="drawer-menu">
                    <!-- 首页 -->
                    <div class="menu-item" :class="{ active: activeMenu === 'index' }" @click="handleMenuClick('index')">
                        <i class="icon icon-home"></i>
                        <span>Home</span>
                    </div>

                    <!-- 产品中心 -->
                    <div class="menu-item" :class="{ active: activeMenu === 'products' }" @click="handleMenuClick('products')">
                        <i class="icon icon-product"></i>
                        <span>Products</span>
                    </div>

                    <!-- 关于我们 -->
                    <div class="menu-item" :class="{ active: activeMenu === 'about' }" @click="handleMenuClick('about')">
                        <i class="icon icon-about"></i>
                        <span>About</span>
                    </div>

                    <!-- 联系我们 -->
                    <div class="menu-item" :class="{ active: activeMenu === 'contactUs' }" @click="handleMenuClick('contactUs')">
                        <i class="icon icon-contact"></i>
                        <span>Contact</span>
                    </div>

                    <!-- 语言切换 -->
                    <div class="menu-item lang-item" @click="switchToChinese">
                        <img class="icon " src="@/assets/images/en/changecna.png" alt="">

                        <span>中文</span>
                    </div>
                </div>
            </div>
        </el-drawer>
        <div class="content" ref="content">
            <!-- 导航 -->
            <div class="nav_content ">
                <div class="logo" @click="changeindex">
                    <img class="header_logo" src="@/assets/images/all/logo_title.png" alt="两仪万象" />
                </div>
                <div class="header_right">
                    <div class="header_nav fs-14">
                        <ul class="header_nav_content">
                            <li class="nav_item" v-for="(list, index) in navList.slice(0,3)" :key="list.id">
                                <span :class="['item_text', tabactive === index ? 'itemtextactive' : '']" @click="navTarget(list, index)">
                                    {{ list.title }}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div style="display: flex;align-items: center;gap: .2rem;" v-if="specification == 'pc'">
                    <div class="lang-switch" @click="switchToChinese">
                        <img src="@/assets/images/en/changecna.png" alt="">
                    </div>
                    <div class="header_about" @click="navTarget(navList[5],5)">
                        <img src="@/assets/images/index/about.png" alt="">
                        <span style="margin: 0 0 0 .04rem;">Contact Us</span>
                    </div>

                </div>
                <div class="zd">
                    <img @click="drawer = true" class="header_logo" src="@/assets/images/all/zd.png" alt="">
                </div>
            </div>
        </div>
        <!-- 返回顶部 -->
        <div v-if="showTop" class="up_arrow_buttom flexclocen" @click="getScollTop">
            <div><img src="@/assets/images/all/topup_arrow.png" alt="返回顶部" /></div>
            <div class="topup_arrowtext">回到<br />顶端</div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {


    props: ['tabactivetan'],
    data() {
        return {
            drawer: false,
            direction: 'ltr',
            activeSubmenu: null, // 当前激活的子菜单

            showTop: false,
            tabactive: 0,
            navList: [
                { id: 1, title: "Home" },
                { id: 2, title: "Products" },
                { id: 3, title: "About" },
                { id: 4, title: "News" },
                { id: 5, title: "Careers" },
                { id: 6, title: "Contact" },
            ],
            activeMenu: "index"
        };
    },
    computed: {
        ...mapGetters('user', ['specification'])         // 从 getters 里取
    },
    //监控data中的数据变化
    watch: {
        $route: {
            immediate: true,
            handler(val) {
                if (this.$store.state.user.specification == 'pc') return
                if (val) {
                    this.activeMenu = val.name
                }
            }
        }
    }
    ,
    methods: {
        changeindex() {
            this.$router.push('/en/index');
            this.$bus.$emit("nextaboutitem", 0);
        },
        getScollTop() {
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            const timer = setInterval(() => {
                document.documentElement.scrollTop = document.body.scrollTop = top -= 50;
                if (top <= 0) clearInterval(timer);
            }, 5);
        },
        navTarget(data, index) {
            switch (data.id) {
                case 1: this.$router.push('/en/index'); break;
                case 2:
                    this.$router.push('/en/products');
                    this.$store.commit('user/SET_PRODTYPE', "computer")
                    this.$bus.$emit("resetpage", true);
                    break;
                case 3: this.$router.push('/en/about'); break;
                case 4: this.$router.push('/en/businessmovement'); break;
                case 5: this.$router.push('/en/hiring'); break;
                case 6: this.$router.push('/en/contactUs'); break;
                default: break;
            }
            this.tabactive = index;
        },
        handleScroll() {
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            const item = this.$refs.content;

            // 判断移动端还是桌面端
            if (window.innerWidth <= 750) {
                // 移动端逻辑
                item.style.background = 'none';
            } else {
                // 桌面端逻辑
                item.style.background = scrollY === 0 ? 'none' : 'rgba(68, 10, 156,0.8)';
            }

            this.showTop = scrollY > 1080;
            this.getheaderHeight();
        },
        getheaderHeight() {
            let dom = this.$refs.content;
            this.$bus.$emit("headerHeight", dom.offsetHeight);
        },
        // 菜单点击处理方法
        handleMenuClick(menuKey) {
            // 1. 更新当前激活的菜单项
            this.activeMenu = menuKey;
            // 2. 关闭抽屉菜单
            this.drawer = false;

            console.log(menuKey)

            this.$router.push(`/en/${menuKey}`); // 英文首页路由
        },
        // 切换到中文
        switchToChinese() {
            this.$router.push('/index');
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.getheaderHeight();
        this.tabactive = this.tabactivetan;
        this.$bus.$on("nextaboutitem", (index) => {
            this.tabactive = index;
        });
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
};
</script>

<style lang="scss" scoped>
a {
    text-decoration: none;
}

.fs-14 {
    font-size: 0.14rem;
    line-height: 2;
}

.header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;

    .content {
        height: 0.6rem;
        display: flex;
        align-items: center;
        // background: rgba(255, 255, 255, 0.37);
    }

    .nav_content {
        height: 0.6rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 15.86rem;
        margin: 0 auto;

        .logo {
            width: 2rem;
            padding: 0.05rem;
            display: flex;
            align-items: center;
            cursor: pointer;
            // padding-left: 0.2rem;

            img {
                width: 100%;
                height: 100%;
                border-radius: 0.07rem;
            }
        }

        .header_right {
            display: flex;
            align-items: center;

            .header_nav {
                .nav_item {
                    display: flex;
                    align-items: center;

                    .item_text {
                        font-family: "NotoSansHans-Regular";
                        font-weight: 400;
                        font-size: 0.16rem;
                        color: #ffffff;
                        width: 1.3rem;
                        height: 0.6rem;
                        cursor: pointer;
                        font-style: normal;
                        text-transform: none;
                        display: block;
                        text-align: center;
                        line-height: 0.6rem;
                    }
                    .itemtextactive {
                        background: url("@/assets/images/all/nav_bgactive.png")
                            no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
        }
        .header_about {
            width: 1.2rem;
            height: 0.32rem;
            background: linear-gradient(
                90deg,
                rgba(197, 201, 255, 0.3) 0%,
                #ab62ff 100%
            );
            box-shadow: 0rem 0.05rem 0.08rem 0rem rgba(158, 178, 219, 0.24);
            border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
            // opacity: 0.7;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 0.14rem;
            img {
                width: 0.16rem;
                height: 0.16rem;
            }
        }
        .lang-switch {
            // width: 0.5rem;
            // height: 0.32rem;
            // border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 0.2rem;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 0.12rem;
            margin-left: 0.15rem;
            transition: all 0.3s;
            &:hover {
                background: rgba(255, 255, 255, 0.1);
                border-color: rgba(255, 255, 255, 0.5);
            }
        }
    }
}
.header .header_nav .header_nav_content {
    display: flex;
    align-items: center;
}
// 返回顶部按钮
.up_arrow_buttom {
    position: fixed;
    background: linear-gradient(
        180deg,
        rgba(65, 57, 192, 0.93) 0%,
        rgba(0, 1, 45, 0.93) 100%
    );

    border-radius: 0.4rem 0.4rem 0.4rem 0.4rem;
    width: 0.42rem;
    height: 1rem;
    z-index: 9999;
    right: 0.2rem;
    bottom: 1rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    flex-direction: column;
    font-size: 0.12rem;
    .topup_arrowtext {
        color: #ffffff;
    }
    img {
        width: 0.24rem;
        height: 0.24rem;
    }
    &:hover {
        background: linear-gradient(179deg, #a940e5 0%, #2b27ff 100%);
    }
}

// @media screen and (max-width: 7.5rem) {
//     .up_arrow_buttom {
//         width: 0.8rem;
//         height: 0.8rem;
//         bottom: 1.4rem;

//         img {
//             width: 0.4rem;
//             height: 0.4rem;
//             top: 27%;
//             left: 27%;
//         }
//     }
// }
.zd {
    display: none;
}

@media screen and (max-width: 750px) {
    .header {
        position: absolute;
        .header_right,
        .header_about {
            display: none !important;
        }
        .zd {
            display: block;
            width: 0.44rem;
            height: 0.44rem;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .content {
            margin: 0.3rem 0.28rem !important;
            .logo {
                width: 2.5rem;
            }
        }
        ::v-deep .el-drawer {
            width: 60% !important; /* 固定宽度匹配UI */
            background-color: #0f0f23; /* 深色背景 */
            padding: 0;
            border: none;
        }

        ::v-deep .el-drawer__header {
            margin: 0;
            padding: 0.2rem 0.24rem 0.2rem 0.48rem; /* 顶部内边距 */
        }
        .drawer-title {
            display: flex;
            align-items: center;
            justify-content: space-between; /* Logo 左，关闭按钮右 */
            width: 100%;
            padding: 0.1rem 0;
        }

        .drawer-title .logo img {
            height: 0.4rem; /* 可根据需求调整 */
            cursor: pointer;
            width: 100%;
            height: 100%;
        }

        ::v-deep .el-drawer__close-btn {
            color: #ffffff; /* 白色关闭按钮 */
            font-size: 0.24rem;
            width: 0.36rem;
            text-align: center;
        }

        .drawer-content {
            box-sizing: border-box;
            // margin: .1rem 0 0 0;
        }

        .logo {
            padding: 0;
            border-bottom: 0.01rem solid rgba(255, 255, 255, 0.05);
            width: 2.5rem;
            display: flex;
            align-items: center;
            flex-direction: column;
            .header_logo {
                width: 1.5rem;
                height: 0.44rem;
            }
        }

        .menu-title {
            color: #ffffff;
            font-size: 0.26rem;
            padding: 0 0.24rem 0.12rem;
            padding: 0.16rem 0.24rem 0.2rem 0.48rem; /* 顶部内边距 */

            font-weight: 500;
        }

        .drawer-menu {
            padding: 0;
        }

        .menu-item {
            height: 0.7rem;
            display: flex;
            align-items: center;
            padding: 0.16rem 0.24rem 0.2rem 0.48rem; /* 顶部内边距 */

            color: #ffffff;
            font-size: 0.24rem;
            cursor: pointer;
            transition: background-color 0.3s;
        }

        .menu-item.active {
            background-color: #3c0081; /* 选中项紫色背景 */
        }

        .menu-item:not(.active):hover {
            background-color: rgba(255, 255, 255, 0.05);
        }

        .icon {
            width: 0.4rem;
            height: 0.4rem;
            margin-right: 0.16rem;
            border-radius: 0.04rem;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background-size: 0.18rem 0.18rem;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
        }

        // /* 图标背景图 - 替换为实际图标路径 */
        .icon-home {
            background-image: url("@/assets/images/all/home.png");
        }

        .icon-product {
            background-image: url("@/assets/images/all/product.png");
        }

        .icon-about {
            background-image: url("@/assets/images/all/about.png");
        }

        .icon-news {
            background-image: url("@/assets/images/all/news.png");
        }

        .icon-join {
            background-image: url("@/assets/images/all/contact.png");
        }

        .icon-contact {
            background-image: url("@/assets/images/all/join.png");
        }
        .icon-changeLanguage {
            background-image: url("@/assets/images/all/contact.png");
        }

        .icon-lang {
            background-image: url("@/assets/images/all/clone.png");
        }

        .lang-item {
            border-top: 1px solid rgba(255, 255, 255, 0.1);
            margin-top: 0.1rem;
            padding-top: 0.1rem;
        }
    }
}

@media screen and (max-width: 750px) {
    .up_arrow_buttom {
        position: fixed;
        background-color: #085bf9;
        width: 0.65rem;
        height: 1.2rem;
        z-index: 9999;
        right: 0.2rem;
        bottom: 1.4rem;
        cursor: pointer;
        font-size: 0.2rem !important;
        img {
            display: inline-flex;
            // position: absolute;
            // width: 0.4rem;
            // height: 0.4rem;
            // top: 27%;
            // left: 27%;
        }
    }
}
</style>
